<script lang="ts">
export default {
  name: "MainFobizzNavbarNotificationIcon",
};
</script>

<script setup lang="ts">
import BaseIcon from "@/components/Base/Icon/index.vue";

const userStore = useUserStore();
</script>

<template>
  <div class="icon-with-alert-badge">
    <BaseIcon icon-name="bell" color="inherit" size="inherit" />
    <span v-if="userStore.hasUnreadPosts" class="alert-badge"></span>
  </div>
</template>

<style scoped lang="scss">
.icon-with-alert-badge {
  position: relative;
  display: flex;

  .alert-badge {
    position: absolute;
    top: 20%;
    left: 80%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 1px solid white;
    background-color: $danger;
    padding: 3px;
  }
}
</style>
